// Is this page load a sign-in popup coming back with its answer?
//
// MSAL encodes its own state in the `state` parameter: base64url JSON
// ({ id, meta: { interactionType } }), then "|" and any app state. That survives
// the round trip through the identity provider's pages, unlike window.opener or the window
// name, which cross-origin isolation can sever. Same test MSAL itself uses.

function decodeBase64Url(s: string): string {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function isMsalPopupResponse(href: string): boolean {
  try {
    const url = new URL(href);
    const params = new URLSearchParams(url.hash.startsWith('#') ? url.hash.slice(1) : url.hash);
    const state = params.get('state') ?? url.searchParams.get('state');
    const hasAnswer = params.has('code') || params.has('error') || url.searchParams.has('code') || url.searchParams.has('error');
    if (!state || !hasAnswer) return false;
    const library = JSON.parse(decodeBase64Url(state.split('|')[0] ?? '')) as { meta?: { interactionType?: unknown } };
    return library.meta?.interactionType === 'popup';
  } catch {
    return false;
  }
}
